'use client';

import React from 'react';
import useAccount from '@/lib/hooks/useAccount';
import useAuthDrawer from '../auth-drawer-provider/hooks/useAuthDrawer';
import { REGISTRATION_DRAWER_ID } from '../registration-drawer';
import RegisterTradeAccountButton from './register-trade-account-button';
import type { RegisterTradeAccountVariant } from './types';

interface RegisterTradeAccountTriggerProps {
  variant: RegisterTradeAccountVariant;
  className?: string;
}

/**
 * Guest-only "Register Trade Account" CTA. Opens the Account Registration
 * drawer via AuthDrawerProvider (`open('register')`) — the `?auth=register`
 * URL form is the inbound deep-link entry, handled by the provider, not
 * written here (per the Auth epic EWM-265/266 contract). Renders nothing for
 * authenticated / still-loading users so the chrome doesn't flicker.
 */
const RegisterTradeAccountTrigger = ({ variant, className }: RegisterTradeAccountTriggerProps) => {
  const { loggedIn, isLoading } = useAccount();
  const { mode, open } = useAuthDrawer();

  if (isLoading || loggedIn) return null;

  return (
    <RegisterTradeAccountButton
      variant={variant}
      controlsId={REGISTRATION_DRAWER_ID}
      isOpen={mode === 'register'}
      onClick={() => open('register')}
      className={className}
    />
  );
};

export default RegisterTradeAccountTrigger;
